import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-monero',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Monero icon</title><path d="M12 0C5.365 0 0 5.373 0 12.015c0 1.335.228 2.607.618 3.81h3.577V5.729L12 13.545l7.805-7.815v10.095h3.577c.389-1.203.618-2.475.618-3.81C24 5.375 18.635 0 12 0zm-1.788 15.307l-3.417-3.421v6.351H1.758C3.87 21.689 7.678 24 12 24s8.162-2.311 10.245-5.764h-5.04v-6.351l-3.386 3.421-1.788 1.79-1.814-1.79h-.005z"/></svg>`,
    styles: []
})
export class SimpleIconsMoneroComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#FF6600';
    @Input() className: string = 'simple-icons-monero'
    constructor() {}
    ngOnInit(): void {}
}
